"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _material = require("@mui/material");

var _Typography = _interopRequireDefault(require("../Typography/Typography.overrides"));

var _Icon = require("../Icon");

var _jsxRuntime = require("react/jsx-runtime");

var _excluded = ["children", "variant", "anchorOrigin", "autoHideDuration", "open"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var StyledBox = (0, _material.styled)(_material.Box)(function (_ref) {
  var theme = _ref.theme;
  return {
    "&.error": {
      borderColor: theme.palette.error.main
    },
    "&.success": {
      borderColor: theme.palette.success.main
    },
    "&.warning": {
      borderColor: theme.palette.warning.main
    },
    alignItems: "stretch",
    backgroundColor: "#fff",
    border: "1px solid",
    borderRadius: "4px",
    display: "flex",
    fontSize: _Typography.default.MuiTypography.body3.fontSize,
    maxWidth: "23rem",
    padding: theme.spacing(3)
  };
});
var StyledContainer = (0, _material.styled)("div")(function (_ref2) {
  var theme = _ref2.theme;
  return {
    "&.error": {
      backgroundColor: theme.palette.error.main
    },
    "&.success": {
      backgroundColor: theme.palette.success.main
    },
    "&.warning": {
      backgroundColor: theme.palette.warning.main
    },
    alignItems: "center",
    color: "#fff",
    display: "flex",
    justifyContent: "center",
    margin: "-".concat(theme.spacing(3)),
    marginRight: theme.spacing(3),
    maxWidth: "3rem",
    minWidth: "3rem"
  };
});
var variants = {
  error: {
    icon: "times",
    role: "alert"
  },
  success: {
    icon: "check",
    role: "status"
  },
  warning: {
    icon: "exclamation",
    role: "status"
  }
};

var Toast = function Toast(_ref3) {
  var children = _ref3.children,
      _ref3$variant = _ref3.variant,
      variant = _ref3$variant === void 0 ? "success" : _ref3$variant,
      _ref3$anchorOrigin = _ref3.anchorOrigin,
      anchorOrigin = _ref3$anchorOrigin === void 0 ? {
    horizontal: "right",
    vertical: "bottom"
  } : _ref3$anchorOrigin,
      _ref3$autoHideDuratio = _ref3.autoHideDuration,
      autoHideDuration = _ref3$autoHideDuratio === void 0 ? 6000 : _ref3$autoHideDuratio,
      _ref3$open = _ref3.open,
      open = _ref3$open === void 0 ? false : _ref3$open,
      rest = (0, _objectWithoutProperties2.default)(_ref3, _excluded);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Snackbar, _objectSpread(_objectSpread({
    anchorOrigin: anchorOrigin,
    autoHideDuration: autoHideDuration,
    open: open,
    role: variants[variant].role
  }, rest), {}, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledBox, {
      className: variant,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(StyledContainer, {
        className: variant,
        role: "presentation",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
          iconName: variants[variant].icon,
          size: "large"
        })
      }), children]
    })
  }));
};

var _default = Toast;
exports.default = _default;